import { FC, forwardRef, type CSSProperties } from "react";
import { DropdownListComponentProps } from "../../interface";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";

type Option = Record<string, unknown>;

const DropDownListComponent: FC<DropdownListComponentProps & Record<string, any>> = forwardRef((props, ref) => {
  const {
    dataSource = [],
    fields = { text: "text", value: "value" },
    value,
    onChange,
    setValue,
    change,
    placeholder,
    disabled,
    enabled,
    width,
    allowFlexGrow,
    ...rest
  } = props;

  const options: Option[] = Array.isArray(dataSource) ? dataSource : [];
  const textField = fields?.text || "text";
  const valueField = fields?.value || "value";

  // enabled (Syncfusion) takes priority over disabled if both provided
  const isDisabled = enabled !== undefined ? !enabled : (disabled ?? false);

  // Resolve string value → option object
  const resolvedValue: Option | null = (() => {
    if (value == null) return null;
    if (typeof value === "object") return value as Option;
    return options.find((o) => o[valueField] === value) ?? null;
  })();

  const handleChange = (option: Option | Option[] | null) => {
    if (!option || Array.isArray(option)) return;
    const syntheticEvent = { value: option[valueField], itemData: option };
    if (onChange) onChange(syntheticEvent);
    if (setValue) setValue(syntheticEvent);
    if (change) change(syntheticEvent);
  };

  const containerStyle: CSSProperties = {
    width: width || "100%",
    display: "flex",
    flexDirection: "column",
    ...(allowFlexGrow ? { flexGrow: 1 } : {}),
  };

  return (
    <div style={containerStyle}>
      <SelectDropDown
        ref={ref as any}
        options={options}
        value={resolvedValue}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={isDisabled}
        fields={{ text: textField, value: valueField }}
        {...rest}
      />
    </div>
  );
});

DropDownListComponent.displayName = "DropDownListComponent";
export default DropDownListComponent;
